/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Card,
  CardBody,
  Container,
  HStack,
  Heading,
  IconButton,
  ListItem,
  OrderedList,
  Text,
  UnorderedList,
} from '@mybridge/ui';
import React, { useEffect } from 'react';
import Head from 'next/head';
import { useDispatch, useSelector } from 'react-redux';
import { getStaticPageContent } from 'v4/store/actions/global.data.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { BackArrow, BackArrowRTL } from '@mybridge/icons';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { useRouter } from 'next/router';
const TermsOfUse = () => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const direction = useDirection();
  const router = useRouter();
  const { pageContetStatic } = useSelector((state) => state.globalData);
  useEffect(() => {
    dispatch(getStaticPageContent('terms-conditions'));
  }, []);
  return (
    <>
      <Head>
        <title>{t('aboutPage.termsOfUse') || "Terms of Use"} - mybridge</title>
        <meta
          name="description"
          content='myBridge.me is a professional Social networking site, this page shows the terms of service ("Terms") cover your use and access to our services, client software, and websites ("Services").'
        />
        <meta
          name="keywords"
          content="Job finding websites, Best job boards, Top job search engines
          , Social Media Platforms, top 10 social media sites USA, 
          Shareable online calendar, Secure Online Document Storage, 
          Free Online Meeting Tools, Audio video calls
          "
        />
      </Head>
      {/* <Box bg="#3D5A80" position="static" top="0" left="0" right="0" py="18px">
        <Container maxW="1366px">
          <HStack w="100%" justifyContent="space-between">
            <Heading color="#fff" fontSize="24px" fontWeight="bold">
              Terms and Conditions
            </Heading>
            <Text color="#fff" fontSize="16px" fontWeight="normal">
              Home / Terms and Conditions
            </Text>
          </HStack>
        </Container>
      </Box> */}
      <Container maxW="1366px" className="static-page-container" >
        <Card className="static-page-body" boxShadow="none">
          <CardBody>
            <Heading as="h1" fontSize="24px" color="#3D5A80" mb={1}>
              <IconButton size="sm" variant="transparent" onClick={() => router.back()} icon={direction === 'rtl' ? <BackArrowRTL/> : <BackArrow />} />
              {t('otherModules.terms_and_conditions') || "Terms and Conditions"}
            </Heading>
            <Box
            className="static-page-body"
              dangerouslySetInnerHTML={{
                __html: pageContetStatic?.content,
              }}
            ></Box>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default TermsOfUse;
